module.exports = __webpack_public_path__ + "img/icon5.bb48b32a.png";